import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { AUTH_URL } from "../../../utils/constants";

const Registration = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    gender: "Female",
    address: "",
    country: "",
    state: "",
    district: "",
    email: "",
    password: "",
    mobile: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    address: "",
    country: "",
    state: "",
    district: "",
    email: "",
    password: "",
    mobile: "",
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const validate = () => {
    let isValid = true;
    let newErrors = {};

    // Name validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
      isValid = false;
    }



    // Address validation
    if (!formData.address.trim()) {
      newErrors.address = "Address is required.";
      isValid = false;
    }

    // Country validation
    if (!formData.country.trim()) {
      newErrors.country = "Country is required.";
      isValid = false;
    }

    // State validation
    if (!formData.state.trim()) {
      newErrors.state = "State is required.";
      isValid = false;
    }

    // District validation
    if (!formData.district.trim()) {
      newErrors.district = "District is required.";
      isValid = false;
    }

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
    ) {
      newErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    // Password validation
    if (!formData.password.trim()) {
      newErrors.password = "Password is required.";
      isValid = false;
    }

    // Mobile validation
    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required.";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      // Proceed with form submission
      try {
        let response = await axios.post(
          `${AUTH_URL}userregistration`,
          { ...formData, firstname: formData.name },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response?.status === 201) {
          console.log(response, "line124");
          sessionStorage.setItem("email", response?.data?.email);
          navigate("/EmailVerification");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${response?.data?.message}`,
          });
        }
      } catch (error) {
        console.log("Error in registration api", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error in registration api!",
        });
      }
      // navigate("/EmailVerification");
    }
  };

  return (
    // <div className="flex items-center justify-center py-[30px] ">
    //   <div className="w-[90%] border shadow-lg rounded-sm bg-white p-[25px]">
    //     <h1 className="mb-2 text-lg font-bold text-blue">
    //       Registration Details
    //     </h1>
    //     <form onSubmit={handleSubmit}>
    //       <div className="flex flex-wrap justify-between gap-x-3">
    //         {/* Name Field */}
    //         <div className="my-3 w-[47%]">
    //           <label
    //             htmlFor="name"
    //             className="block text-sm font-medium text-gray-700"
    //           >
    //             Name<span className="text-red-500">*</span>
    //           </label>
    //           <input
    //             type="text"
    //             id="name"
    //             value={formData.name}
    //             onChange={handleChange}
    //             className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //               errors.name ? "border-red-500" : "border-gray-300"
    //             } focus:ring-indigo-500 focus:border-indigo-500`}
    //             placeholder="Enter your name"
    //           />
    //           {errors.name && (
    //             <p className="mt-1 text-sm text-red-500">{errors.name}</p>
    //           )}
    //         </div>

    //         {/* Gender Dropdown */}
    //         <div className="my-3 w-[47%]">
    //           <label
    //             htmlFor="gender"
    //             className="block text-sm font-medium text-gray-700"
    //           >
    //             Gender<span className="text-red-500">*</span>
    //           </label>
    //           <select
    //             id="gender"
    //             value={formData.gender}
    //             onChange={handleChange}
    //             className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //               errors.gender ? "border-red-500" : "border-gray-300"
    //             } focus:ring-indigo-500 focus:border-indigo-500`}
    //           >
    //             <option value="">Select Gender</option>
    //             <option value="Male">Male</option>
    //             <option value="Female">Female</option>
    //             <option value="Other">Other</option>
    //           </select>
    //           {errors.gender && (
    //             <p className="mt-1 text-sm text-red-500">{errors.gender}</p>
    //           )}
    //         </div>

    //         {/* Address Field */}
    //         <div className="my-3 w-[47%]">
    //           <label
    //             htmlFor="address"
    //             className="block text-sm font-medium text-gray-700"
    //           >
    //             Address<span className="text-red-500">*</span>
    //           </label>
    //           <input
    //             type="text"
    //             id="address"
    //             value={formData.address}
    //             onChange={handleChange}
    //             className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //               errors.address ? "border-red-500" : "border-gray-300"
    //             } focus:ring-indigo-500 focus:border-indigo-500`}
    //             placeholder="Enter your address"
    //           />
    //           {errors.address && (
    //             <p className="mt-1 text-sm text-red-500">{errors.address}</p>
    //           )}
    //         </div>

    //         {/* Remaining fields (country, state, district, email, mobile) */}
    //         {[
    //           "country",
    //           "state",
    //           "district",
    //           "email",
    //           "password",
    //           "mobile",
    //         ].map((field, index) => (
    //           <div className="my-3 w-[47%]" key={index}>
    //             <label
    //               htmlFor={field}
    //               className="block text-sm font-medium text-gray-700"
    //             >
    //               {field.charAt(0).toUpperCase() + field.slice(1)}
    //               <span className="text-red-500">*</span>
    //             </label>
    //             <input
    //               type={
    //                 field === "email"
    //                   ? "email"
    //                   : field === "mobile"
    //                   ? "number"
    //                   : "text"
    //               }
    //               id={field}
    //               value={formData[field]}
    //               onChange={handleChange}
    //               className={`block w-full mt-1 p-1.5 bg-gray-200 border rounded-md shadow-sm sm:text-sm ${
    //                 errors[field] ? "border-red-500" : "border-gray-300"
    //               } focus:ring-indigo-500 focus:border-indigo-500`}
    //               placeholder={`Enter your ${field}`}
    //             />
    //             {errors[field] && (
    //               <p className="mt-1 text-sm text-red-500">{errors[field]}</p>
    //             )}
    //           </div>
    //         ))}
    //       </div>
    //       <div className="mt-4 mb-3 flex justify-center">
    //         <button
    //           type="submit"
    //           className="w-[20%] bg-[#251e8a] py-1.5 text-white rounded-md"
    //         >
    //           Submit
    //         </button>
    //       </div>
    //     </form>
    //   </div>
    // </div>
    <div className="flex-grow flex sm:items-center justify-center bg-page-bg px-2 sm:px-4 py-4 w-full h-full overflow-y-auto">
      <div className="w-full max-w-5xl bg-white rounded-xl shadow-md p-5 md:p-8 my-auto">
        <h2 className="text-center text-lg font-semibold text-brand-teal mb-1">
          Registration
        </h2>
        <p className="text-center text-sm text-gray-600 mb-4">
          Please fill in your details to create an account
        </p>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { id: "name", label: "Name" },
              { id: "address", label: "Address" },
              { id: "country", label: "Country" },
              { id: "state", label: "State" },
              { id: "district", label: "District" },
              { id: "email", label: "Email", type: "email" },
              { id: "password", label: "Password", type: "password" },
              { id: "mobile", label: "Mobile", type: "tel" },
            ].map(({ id, label, type }) => (
              <div key={id}>
                <label
                  htmlFor={id}
                  className="block text-sm font-medium text-gray-700 mb-0.5"
                >
                  {label} <span className="text-red-500">*</span>
                </label>

                {type === "select" ? (
                  <select
                    id={id}
                    value={formData[id]}
                    onChange={handleChange}
                    className={`w-full px-3 py-1.5 border ${errors[id] ? "border-red-500" : "border-gray-300"
                      } rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-300`}
                  >
                    <option value="">Select Option</option>
                  </select>
                ) : (
                  <input
                    id={id}
                    type={type || "text"}
                    placeholder={`Enter your ${label.toLowerCase()}`}
                    value={formData[id]}
                    onChange={handleChange}
                    className={`w-full px-3 py-1.5 border ${errors[id] ? "border-red-500" : "border-gray-300"
                      } rounded-md bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-300`}
                  />
                )}

                {errors[id] && (
                  <p className="text-sm text-red-500 mt-1">{errors[id]}</p>
                )}
              </div>
            ))}
          </div>

          <div className="mt-4 flex justify-center">
            <button
              type="submit"
              className="w-full sm:w-1/2 bg-brand-teal text-white py-2 rounded-md shadow hover:opacity-95 transition font-medium"
            >
              Register
            </button>
          </div>

          <div className="mt-4 text-center text-sm">
            <span
              className="text-gray-800 hover:underline cursor-pointer"
              onClick={() => navigate("/login")}
            >
              Already have an account? Sign In
            </span>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Registration;
